import { UUID } from '@/types/Id'

interface SchedulesQueryKeyArgs {
  orgId: UUID | ''
}

interface ScheduleQueryKeyArgs {
  scheduleId: UUID | ''
}

export const schedulesQueryKeys = {
  all: () => ['schedules'] as const,
  organization: (keyArgs: SchedulesQueryKeyArgs) =>
    ['schedules', keyArgs.orgId] as const,
}

export const scheduleQueryKeys = {
  schedule: (keyArgs: ScheduleQueryKeyArgs) =>
    ['schedule', keyArgs.scheduleId] as const,
}
